/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  BulkMatchVariantsMutationRequest,
  BulkMatchVariantsMutationResponse,
  BulkMatchVariants400,
} from '../types/BulkMatchVariants'

function getBulkMatchVariantsUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/products/catalog/variants/bulk-match/` as const,
  }
  return res
}

/**
 * @description Bulk match variants to products.
 * POST /variants/bulk-match/
 * Supports three modes:
 * Explicit mode (legacy):
 * {
 * "matches": [
 * {"variant_id": 1, "product_id": 10},
 * {"variant_id": 2, "product_id": 10},
 * ...
 * ]
 * }
 * Select-all link mode:
 * {
 * "product_id": 10,
 * "filters": {
 * "match_status": "unmatched",
 * "search": "keyword"
 * },
 * "exclude_ids": [5, 12]  // optional
 * }
 * Select-all unlink mode:
 * {
 * "unlink_mode": true,
 * "filters": {
 * "match_status": "matched",
 * "product": [10]
 * },
 * "exclude_ids": [5, 12]  // optional
 * }
 * Returns:
 * {
 * "matched_count": 2,
 * "failed_count": 0,
 * "errors": []
 * }
 * @summary Bulk match variants to products
 * {@link /api/v1/products/catalog/variants/bulk-match/}
 */
export async function bulkMatchVariants(
  data?: BulkMatchVariantsMutationRequest,
  config: Partial<RequestConfig<BulkMatchVariantsMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    BulkMatchVariantsMutationResponse,
    ResponseErrorConfig<BulkMatchVariants400>,
    BulkMatchVariantsMutationRequest
  >({
    method: 'POST',
    url: getBulkMatchVariantsUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
